/**
 * 号码补零标准化：1-49 补零为两位，其它保留原样
 */
export function normalizeBallNum(val) {
  const s = String(val == null ? '' : val).trim()
  if (!s) return ''
  const n = parseInt(s, 10)
  if (Number.isNaN(n) || n < 1 || n > 49) return s.length <= 2 ? s.padStart(2, '0') : s
  return n < 10 ? `0${n}` : String(n)
}

/**
 * 逗号/中文逗号分割
 */
export function splitCsv(s) {
  if (s == null || s === '') return []
  return String(s)
    .split(/[,，]/)
    .map(x => x.trim())
    .filter(Boolean)
}

/**
 * API 波色标准化（未知返回空字符串）
 */
export function normalizeApiTone(c) {
  if (c == null || typeof c !== 'string') return ''
  const x = c.trim().toLowerCase()
  if (x === 'red' || x === 'blue' || x === 'green') return x
  return ''
}

/**
 * 历史波色标准化（未知返回 'blue'）
 */
export function normalizeHistoryTone(c) {
  if (c == null || typeof c !== 'string') return 'blue'
  const x = c.trim().toLowerCase()
  if (x === 'red' || x === 'blue' || x === 'green') return x
  return 'blue'
}

/**
 * 查波色表返回 'red' | 'blue' | 'green'
 * @param {string} val 球号
 * @param {{ red: string[], blue: string[], green: string[] }} tables 波色号码表
 */
export function waveTone(val, tables) {
  const n = normalizeBallNum(val)
  if (tables.red.includes(n)) return 'red'
  if (tables.blue.includes(n)) return 'blue'
  if (tables.green.includes(n)) return 'green'
  return 'blue'
}

const ZODIAC_T2S = { 龍: '龙', 馬: '马', 雞: '鸡', 豬: '猪' }

/**
 * 生肖繁体→简体（仅字形转换，不改变生肖）
 */
export function toSimplifiedZodiac(z) {
  if (z == null || z === '') return ''
  const s = String(z).trim()
  if (!s) return ''
  let out = ''
  for (const ch of s) out += ZODIAC_T2S[ch] || ch
  return out
}

export const NUMBER_ELEMENT = {
  '金': [4, 5, 12, 13, 26, 27, 34, 35, 42, 43],
  '木': [8, 9, 16, 17, 24, 25, 38, 39, 46, 47],
  '水': [1, 14, 15, 22, 23, 30, 31, 44, 45],
  '火': [2, 3, 10, 11, 18, 19, 32, 33, 40, 41, 48, 49],
  '土': [6, 7, 20, 21, 28, 29, 36, 37]
}

/**
 * 按号码查五行（金木水火土），未知返回空字符串
 */
export function elementOf(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return ''
  for (const el in NUMBER_ELEMENT) {
    if (NUMBER_ELEMENT[el].includes(n)) return el
  }
  return ''
}

/**
 * 球对象工厂
 */
export function createBall(value, zodiac, element, tone) {
  return {
    value: normalizeBallNum(value),
    zodiac: zodiac || '',
    element: element || '',
    tone: tone || ''
  }
}
